import { render } from "./404.vue?vue&type=template&id=3f9d3e10"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=3f9d3e10&lang=scss"
script.render = render

export default script